import {StyleSheet} from 'react-native';

import {indent, screenWidth} from '/constant/layout.constant';
import {cloudLight, darkGray, onyx} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  base: {},
  header: {
    paddingVertical: indent,
    borderBottomWidth: 1,
    borderBottomColor: cloudLight,
  },
  listItem: {
    borderBottomWidth: 1,
    borderBottomColor: cloudLight,
  },
  listItemText: {
    color: onyx,
  },
  bonusProgressBar: {
    paddingVertical: indent * 0.8,
    borderBottomColor: cloudLight,
    borderBottomWidth: 1,
  },
  divider: {
    borderBottomWidth: 1,
    borderBottomColor: cloudLight,
    marginVertical: indent * 0.75,
  },
  headerContainer: {
    marginBottom: 10,
    flexDirection: 'row',
  },
  incentiveTripContent: {
    paddingVertical: 16,
    alignSelf: 'center',
    width: screenWidth() - indent,
    borderBottomWidth: 1,
    borderBottomColor: cloudLight,
  },
  heading: {
    paddingBottom: indent * 0.25,
    alignItems: 'center',
  },
  subHeading: {
    flexDirection: 'row',
    justifyContent: 'space-evenly',
  },
  requirements: {
    alignSelf: 'flex-end',
  },
  path: {
    flex: 1,
    fontSize: 12,
    alignSelf: 'flex-end',
    color: darkGray,
    marginLeft: indent,
  },
  daysLeft: {
    flex: 0,
    fontSize: 12,
    alignSelf: 'flex-end',
    color: darkGray,
  },
});
